import $ from "jquery";

const chapters = () => {
  const init = () => {
    disableNextChapter();
  };

  function disableNextChapter() {
    $(function () {
      if ($(".single-question").length < 1) return;

      $(
        '.Chapter__Content--SingleQuestion textarea[name="question"].single_question'
      ).each(function () {
        //disable the Next button initially
        if ($(this).val().trim() !== "") {
          $(
            $(this)
              .closest(".Chapter__Content--SingleQuestion")
              .find(".next-chapter-question")
          ).prop("disabled", false);
        } else {
          //disable the Next button if the question hasn't been answered
          $(
            $(this)
              .closest(".Chapter__Content--SingleQuestion")
              .find(".next-chapter-question")
          ).prop("disabled", true);
        }

        //add an event listener to the textarea
        $($(this)).on("input", function () {
          //check if the question has been asnwered
          if ($(this).val().trim() !== "") {
            $(
              $(this)
                .closest(".Chapter__Content--SingleQuestion")
                .find(".next-chapter-question")
            ).prop("disabled", false);
          } else {
            //disable the Next button if the question hasn't been answered
            $(
              $(this)
                .closest(".Chapter__Content--SingleQuestion")
                .find(".next-chapter-question")
            ).prop("disabled", true);
          }
        });
      });

      // //disable the Next button initially
      // $(btnNext).prop("disabled", true);

      // //add an event listener to the textarea
      // $(textarea).on("input", function () {
      //   //check if the question has been asnwered
      //   if ($(this).val().trim() !== "") {
      //     $(btnNext).prop("disabled", false);
      //   } else {
      //     //disable the Next button if the question hasn't been answered
      //     $(btnNext).prop("disabled", true);
      //   }
      // });
    });
  }

  init();
};

try {
  chapters();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log("This File Error:", error);
}
